import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';

export const AgencyAdminFormModel: ISedmsFormModel = {
  agencySk: {
    name: 'agencySk',
  },
  agencyLocationSK: {
    name: 'agencyLocationSK',
  },
  serviceStartTime: {
    name: 'serviceStartTime',
  },
  serviceEndTime: {
    name: 'serviceEndTime',
  },
  lunchStartTime: {
    name: 'lunchStartTime',
  },
  lunchEndTime: {
    name: 'lunchEndTime',
  },
  averageWaitTime: {
    name: 'averageWaitTime',
  },
  dateFrequency: {
    name: 'dateFrequency',
  },
  totalAppointmentsMonday: {
    name: 'totalAppointmentsMonday',
  },
  totalAppointmentsTuesday: {
    name: 'totalAppointmentsTuesday',
  },
  totalAppointmentsWednesday: {
    name: 'totalAppointmentsWednesday',
  },
  totalAppointmentsThursday: {
    name: 'totalAppointmentsThursday',
  },
  totalAppointmentsFriday: {
    name: 'totalAppointmentsFriday',
  },
  totalAppointmentsSaturday: {
    name: 'totalAppointmentsSaturday',
  },
  totalAppointmentsSunday: {
    name: 'totalAppointmentsSunday',
  },
  totalStaffMonday: {
    name: 'totalStaffMonday',
  },
  totalStaffTuesday: {
    name: 'totalStaffTuesday',
  },
  totalStaffWednesday: {
    name: 'totalStaffWednesday',
  },
  totalStaffThursday: {
    name: 'totalStaffThursday',
  },
  totalStaffFriday: {
    name: 'totalStaffFriday',
  },
  totalStaffSaturday: {
    name: 'totalStaffSaturday',
  },
  totalStaffSunday: {
    name: 'totalStaffSunday',
  },
  languages: {
    name: 'languages',
  },
  bilingualPsychologist: {
    name: 'bilingualPsychologist',
  },
  bilingualInterpreter: {
    name: 'bilingualInterpreter',
  },
  onSite: {
    name: 'onSite',
  },
  offSite: {
    name: 'offSite',
  },
  serviceManhattan: {
    name: 'serviceManhattan',
  },
  serviceBronx: {
    name: 'serviceBronx',
  },
  serviceBrooklyn: {
    name: 'serviceBrooklyn',
  },
  serviceQueens: {
    name: 'serviceQueens',
  },
  serviceStatenIsland: {
    name: 'serviceStatenIsland',
  },
  sheval: {
    name: 'sheval',
  },
  psychoEval: {
    name: 'psychoEval',
  },
  counseling: {
    name: 'counseling',
  },
  pteval: {
    name: 'pteval',
  },
  oteval: {
    name: 'oteval',
  },
  location: {
    name: 'location',
  },
  operatingMDE:{
    name: 'operatingMDE',
  }
};
